import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { IVente, IVenteListCard } from '../../types/interfaces';
import UserEdit from '../user/UserEdit';

import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBalanceScaleLeft, faBuilding, faCheckCircle, faClipboard, faCommentAlt, faCrown, faExclamationCircle, faExclamationTriangle, faExternalLinkAlt, faFunnelDollar, faHashtag, faMoneyBill, faMoneyCheckAlt, faPen, faPhone, faQuestionCircle, faSave, faSignature, faSpinner, faSquare, faStore, faThLarge, faUser, faUserLock, faUsers, faWallet } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../types/errors';
import { PRIVILEGE } from '../../types/privileges'
import { useAlert } from "react-alert";
import moment from "moment";
import LoadingPage from '../../pages/loading';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';

const VenteListCardComponent = ({ 
  allRows,
  filteredRows,
  selectedProjet,
  calculateParts,
  hideFilterSwitch,
  hideER,
  hideCommission,
  flagFlag
 }: IVenteListCard) => {
  const history = useHistory();
  const alert = useAlert();
  const [withFiltersValue, setWithFiltersValue] = useState(true);
  const [ventes, setVentes] = useState<any[]>([]);
  const [appCount, setAppCount] = useState(0);
  const [magCount, setMagCount] = useState(0);
  const [lotCount, setLotCount] = useState(0);
  const [unknownCount, setUnknownCount] = useState(0);
  const [assAppCount, setAssAppCount] = useState(0);
  const [assMagCount, setAssMagCount] = useState(0);
  const [assUnknownCount, setAssUnknownCount] = useState(0);
  const sPrixNet = ventes.reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : (!calculateParts || t.TYPE_VENTE !== "ASSOCIATION") ? t.PRIX_NET : (t.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)) || 0), 0);
  const sEncaissements = ventes.reduce((e, t) => e + (t.contrat_encaissements?.filter(e => !calculateParts || t.TYPE_VENTE !== "ASSOCIATION" || (t.associations || []).map(t => t.id?.toString()).includes(e.ID_ASS))?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0);
  const sEncaissementsReceptionnes = ventes.reduce((e, t) => e + (t.contrat_encaissements?.filter(e => !calculateParts || t.TYPE_VENTE !== "ASSOCIATION" || (t.associations || []).map(t => t.id?.toString()).includes(e.ID_ASS))?.reduce((e, t) => e + (t.encaissement?.STATUT && [constants.STATUT_ENC_PTF, constants.STATUT_ENC_OLD_VERSEMENT, constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_REPRESENTE, constants.STATUT_ENC_NOTAIRE].includes(t.encaissement.STATUT) && t.PART ? t.PART : 0), 0) || 0), 0);
  const sReliquat = sPrixNet - sEncaissements;

  useEffect(() => {
    if(withFiltersValue && !hideFilterSwitch)
      setVentes(filteredRows)
    else
      setVentes(allRows)
  }, [withFiltersValue, allRows, filteredRows])

  useEffect(() => {
    setAppCount(ventes.filter(e => !e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("APP")).length);
    setMagCount(ventes.filter(e => !e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("MAG")).length);
    setLotCount(ventes.filter(e => !e.isAssLine && e.TYPE && (e.TYPE.toUpperCase().includes("+") || e.TYPE.toUpperCase().includes(constants.VILLA) || e.TYPE.toUpperCase().includes(constants.EQUIPEMENT))).length);
    setUnknownCount(ventes.filter(e => !e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG") && !e.TYPE.toUpperCase().includes("+") && !e.TYPE.toUpperCase().includes(constants.VILLA) && !e.TYPE.toUpperCase().includes(constants.EQUIPEMENT)))).length)

    setAssAppCount(ventes.filter(e => e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("APP")).length);
    setAssMagCount(ventes.filter(e => e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("MAG")).length);
    setAssUnknownCount(ventes.filter(e => e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG")))).length)
  }, [ventes])
  
  const changeWithFiltersHandle = (e) => {
    setWithFiltersValue(e.target.checked);
  };

  return (<>
    {!flagFlag ? <div className="text-center" style={{fontSize: "small", fontStyle: "italic"}}>EN CONSTRUCTION</div> : ventes?.length ? <Container className="CardInfo">
      <Row className="cardTitlesRow" style={{marginBottom: "0.5rem"}}>
        <Col xs="12" sm={hideFilterSwitch ? "12" : "6"} className="border-0">
          <h2 className="title">{selectedProjet?.id === "ALL" ? "Tous les projets" : (selectedProjet?.LIBELE || "-")}</h2>
        </Col>
        {!hideFilterSwitch && <Col xs="12" sm="6" className="venteCardSwitch justify-content-center justify-content-sm-end">
          <CustomInput type="switch" id="withFilters" name="withFiltersSwitch" label="Prendre en compte les filtres" checked={withFiltersValue} onChange={changeWithFiltersHandle} />
        </Col>}
      </Row>
      <Row>
        <Col xs="12" style={{textAlign: "center"}}>
          <h3>{ventes.length} biens{ventes.filter(e => e.isAssLine).length ? " (et parts)" : ""} vendus</h3>
        </Col>
      </Row>
      <Row className="justify-content-around">
        <Col xs="6" sm={unknownCount > 0 ? "3" : "4"} className="border-0 text-center">
          <FontAwesomeIcon icon={faSquare} />&nbsp;<strong>Lots : </strong>{lotCount}
        </Col>
        <Col xs="6" sm={unknownCount > 0 ? "3" : "4"} className="border-0 text-center">
          <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Appartements : </strong>{appCount}
        </Col>
        <Col xs="6" sm={unknownCount > 0 ? "3" : "4"} className="border-0 text-center">
          <FontAwesomeIcon icon={faStore} />&nbsp;<strong>Magasins : </strong>{magCount}
        </Col>
        {unknownCount ? <Col xs="6" sm="3" className="border-0 text-center">
          <FontAwesomeIcon icon={faQuestionCircle} />&nbsp;<strong>Inconnus : </strong>{unknownCount}
        </Col> : null}
      </Row>
      {assAppCount || assMagCount || assUnknownCount ? <Row className="justify-content-around">
        <Col xs="6" sm={assUnknownCount > 0 ? "4" : "6"} className="border-0 text-center assoCardColor">
          <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Appartements (Association) : </strong>{assAppCount}
        </Col>
        <Col xs="6" sm={assUnknownCount > 0 ? "4" : "6"} className="border-0 text-center assoCardColor">
          <FontAwesomeIcon icon={faStore} />&nbsp;<strong>Magasins (Association) : </strong>{assMagCount}
        </Col>
        {assUnknownCount ? <Col xs="6" sm="4" className="border-0 text-center assoCardColor">
          <FontAwesomeIcon icon={faQuestionCircle} />&nbsp;<strong>Inconnus (Association) : </strong>{assUnknownCount}
        </Col> : null}
      </Row> : null}
      <Row>
        <Col xs="6" lg={ventes.filter(e => e.isAssLine).length ? "4" : "6"} className="border-0 text-center">
          <FontAwesomeIcon icon={faUserLock} />&nbsp;<strong>Ventes normales : </strong>{ventes.filter(e => !e.isAssLine && e.TYPE_VENTE === "UNIQUE").length}
        </Col>
        <Col xs="6" lg={ventes.filter(e => e.isAssLine).length ? "4" : "6"} className="border-0 text-center">
          <FontAwesomeIcon icon={faUsers} />&nbsp;<strong>Associations : </strong>{ventes.filter(e => !e.isAssLine && e.TYPE_VENTE === "ASSOCIATION").length}
        </Col>
        {ventes.filter(e => e.isAssLine).length ? <Col xs="6" lg="4" className="border-0 text-center assoCardColor">
          <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Parts d'association : </strong>{ventes.filter(e => e.isAssLine).length}
        </Col> : null}
      </Row>
      <Row>
        <Col xs="12" className="text-center">
          <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Somme des prix net : </strong>{sPrixNet.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
          &nbsp;{ventes.filter(e => e.isAssLine ? !e.PRIX_VENTE : !e.PRIX_NET).length ? <FontAwesomeIcon icon={faExclamationTriangle} style={{color: "orangered", cursor: "help"}} data-tip data-for="ventesWithNoPriceCard" /> : null}
          {ventes.filter(e => e.isAssLine ? !e.PRIX_VENTE : !e.PRIX_NET).length ? <ReactTooltip effect="solid" id="ventesWithNoPriceCard" type={"dark"}>
            {ventes.filter(e => !e.isAssLine && !e.PRIX_NET).length ? `${ventes.filter(e => !e.isAssLine && !e.PRIX_NET).length} vente${ventes.filter(e => !e.isAssLine && !e.PRIX_NET).length > 1 ? "s" : ""} sans Prix Net` : ""}<br/>
            {ventes.filter(e => e.isAssLine && !e.PRIX_VENTE).length ? `${ventes.filter(e => e.isAssLine && !e.PRIX_VENTE).length} part${ventes.filter(e => e.isAssLine && !e.PRIX_VENTE).length > 1 ? "s" : ""} sans Prix` : ""}
          </ReactTooltip> : null}
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="text-center">
          <FontAwesomeIcon icon={faMoneyCheckAlt} />&nbsp;<strong>Somme des encaissements : </strong>{sEncaissements/* * .1*/.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH {!!sPrixNet && <span className="encPercent" style={{color: "hsl(" + (Math.ceil((sEncaissements * 100) / sPrixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((sEncaissements * 100) / sPrixNet)}%)</span>}
        </Col>
      </Row>
      {!hideER && <Row>
        <Col xs="12" className="text-center">
          <FontAwesomeIcon icon={faWallet} />&nbsp;<strong>Encaissements réceptionnés : </strong>{sEncaissementsReceptionnes/* * .1*/.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
        </Col>
      </Row>}
      <Row>
        <Col xs="12" className="text-center">
          <FontAwesomeIcon icon={faBalanceScaleLeft} />&nbsp;<strong>Reliquat : </strong>{sReliquat.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
        </Col>
      </Row>
      {false && <Row>
        <Col xs="12" className="text-center">
          <FontAwesomeIcon icon={faFunnelDollar} />&nbsp;<strong>Commission : </strong>{(sPrixNet * .005).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
        </Col>
      </Row>}
    </Container> : null}
  </>);
};

export default connect(null, { })(VenteListCardComponent);
